const fechasMixins = {
    data(){
        return {
            
        }
    },
    methods:{
        timestampAFecha(unix_timestamp) {
            var date = new Date(unix_timestamp * 1000);
      
            var anho, mes, dia, horas, minutos;
            this.anio = date.getFullYear();
            this.mes = ("0" + (date.getMonth() + 1)).slice(-2);
            this.dia = ("0" + date.getDate()).slice(-2);
            return `${this.dia}/${this.mes}/${this.anio}`;
        },
        dateAFecha(date) {
            var date = new Date(date);
      
            var anho, mes, dia, horas, minutos;
            this.anio = date.getFullYear();
            this.mes = ("0" + (date.getMonth() + 1)).slice(-2);
            this.dia = ("0" + date.getDate()).slice(-2);
            return `${this.dia}/${this.mes}/${this.anio}`;
        },
        dateAFechaTiempo(date) {
            var date = new Date(date);
            var anho, mes, dia, horas, minutos;
            this.anio = date.getFullYear();
            this.mes = ("0" + (date.getMonth() + 1)).slice(-2);
            this.dia = ("0" + date.getDate()).slice(-2);
            var seconds = date.getSeconds();
            var minutes = date.getMinutes();
            var hour = date.getHours();
            return `${this.dia}/${this.mes}/${this.anio} ${hour}:${minutes}:${seconds}`;
        },
        timeStampAFechaTiempo(date) {
            var date = new Date(date);
            var anho, mes, dia, horas, minutos;
            this.anio = date.getFullYear();
            this.mes = ("0" + (date.getMonth() + 1)).slice(-2);
            this.dia = ("0" + date.getDate()).slice(-2);
            var seconds = date.getSeconds();
            var minutes = date.getMinutes();
            var hour = date.getHours();
            return `${this.dia}/${this.mes}/${this.anio} ${hour}:${minutes}`;
        },
        timestampAFecha2(unix_timestamp, orden='mes') {
            var date = new Date(unix_timestamp * 1000);
            this.anio = date.getFullYear();
            this.mes = ("0" + (date.getMonth() + 1)).slice(-2);
            this.dia = ("0" + date.getDate()).slice(-2);
            var resultado = '';
            if(orden=='mes'){
                resultado = `${this.mes}/${this.dia}/${this.anio}`;
            } else if(orden=='anio'){
                resultado = `${this.anio}/${this.mes}/${this.dia}`;
            }
            return resultado;
        },
        
    }
}

export {
    fechasMixins
}


// WEBPACK FOOTER //
// ./src/mixins/fechasMixins.js